import React, { Component } from 'react';
import { withRouter ,Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Heading from '../../../components/Heading';
import ButtonContainer from '../../../components/ButtonContainer';
import LinkButtons from '../../../components/LinkButtons';
import Dropdown from '../../../components/Dropdown';
import InputBox from '../../../components/InputBox';
import Button from '../../../components/Button';
import Pagination from '../../../components/Pagination';
import CountDisplay from '../../../components/CountDisplay';
import TableHeading from '../../../components/TableHeading';
import TableItem from '../../../components/TableItem';
import Loader from '../../../components/Loader';
import { getCategory } from '../../../models/categories';
import { sortCategories } from '../../../models/sortCategories';
import { domainCategories } from '../../../models/domainCategories';
import { rejectCategories } from '../../../models/rejectMsgCategories';
import { companyRank } from '../../../models/companyRank';
import fetchAllJobs from '../../../services/fetchAllJobs';
import deleteJob from '../../../services/deleteJob';
import refreshJob from '../../../services/refreshJob';
import rejectJob from '../../../services/rejectJob';
import rejectPost from '../../../services/rejectPost';
import unpublishJob from '../../../services/unpublishJob'
import fetchJobsCount from '../../../services/fetchJobsCount';
import fetchRecruiterId from '../../../services/fetchRecruiterId';
import checkPaidJobs from '../../../services/checkPaidJobs';
import bulkReject from '../../../services/bulkReject';
import bulkMigrate from '../../../services/bulkMigrate';
import bulkUnpublish from '../../../services/bulkUnpublish';
import getJUPostingStatus from '../../../services/getJUPostingStatus';
import user from '../../../store/user';
import './Container.scss';
import { maxSalary } from '../../../models/salary';
import fetchVerifiedRecruiters from '../../../services/fetchVerifiedRecruiters';
import { Checkbox, Modal } from 'semantic-ui-react';
import { BulkRejectModal } from '../components/BulkRejectModal';
import moment from "moment";
import { BulkMigrateModal } from '../components/BulkMigrateModal';
import { adminFeatureMapping } from '../../../models/adminFeatureMapping';
import BulkUnpublishModal from '../components/BulkUnpublishModal';

const categoryObj = getCategory();
const migrateToMap = {
    "hirist": 1,
    "updazz": 2,
    "iimjobs": 3
}
class JobListContainer extends Component {

    state = {
        arrow: false,
        asc: null,
        type: null,
        recruiterId: '',
        categoryId: '',
        domainCategory: '',
        rejectMsg:"",
        pageNumber: 1,
        pageContent: 50,
        totalItemsCount: 0,
        joblist: [],
        loader: true,
        adminId: null,
        cacheLoader:false,
        publishId:'',
        showDotInfo: true,
        verificationStatus: {},
        paidJobsNotifyModal: false,
        isSelectAll: false,
        selectedJobs: [],
        rejectJobsReasonModal: false,
        unpublishJobsModal: false,
        rejectJobsModalData: {},
        unpublishJobsModalData: {},
        showBulkActionBtns: false,
        bulkRejectLoading: false,
        bulkUnpublishLoading: false,
        bulkMigratePlatform: null,
        migrateJobsModal: false,
        bulkMigrateLoading: false,
        pendingRejectSort: -1,
        atsJobs: [],
        adminType: null,
        fromMailer: {},
        companyId: '',
    }

    constructor(props) {
        super(props);
        this.maxSalary = [...maxSalary];
        this.maxSalary[0] = { ...maxSalary[0], name: 'Max Salary <' };
    }

    componentDidMount = async () => {
        const profile = await user.getProfile();
        const showDotInfoEmail = process.env.REACT_APP_DOT_INFO_EMAILS;

        const showDisposableFlag = (process.env.REACT_APP_CHAT_GPT_SUGGESTIONS || []).includes(profile.email)

        // if (showDotInfoEmail.indexOf(profile.email) != -1) {
            // this.setState({ showDotInfo: true });
        // }
       
        // const adminEmails=process.env.REACT_APP_EMAILS;

        if (!user.checkFeatureAccess(adminFeatureMapping.JOBS_LIST)) {
            window.location.href='/notAdmin'
        }
       
        // if(adminEmails.indexOf(profile.email)==-1)
        //     window.location.href='/notAdmin'

        const adminId = profile.id;
        const adminType = profile.adminType;
        let queryString = this.props.location.search
        const obj = {};
        // if (!queryString) {
        //     this.fetchCount(adminId ,{})
        //     this.fetchJobs(adminId,{})
        //      return       
        // }
        queryString = queryString.replace('?', '');
        queryString = queryString.split('&');
        for (let i = 0; i < queryString.length; i++) {
            const temp = queryString[i].split('=');
            obj[temp[0]] = temp[1]
        }
        obj.asc = (obj.order === 'asc') ? true : false;
        
        let params={}
            params.email=obj.recruiterId

        // if(isNaN(obj.recruiterId))
        //     console.log(adminId)
        //     fetchRecruiterId(adminId,params).then(res => {
        //         let data = res.data;
        //         this.setState({
        //             recruiterId: data.id
        //         }, () => {
        //             obj.recruiterId=data.id;
        //             parameters.recruiterId=data.id;
        //         });
        // });


        let state = {
            arrow: true,
            type: obj.type,
            asc: obj.order == 'asc' ? true : false,
            rejectMsg:obj.rejectMsg,
            categoryId: obj.categoryId,
            domainCategory: obj.domainCategory,
            recruiterId: obj.recruiterId,
            maxSalLessThan: obj.maxSalLessThan,
            companyRank: obj.companyRank,
            adminId: adminId,
            pageNumber:obj.pageNumber?obj.pageNumber:1,
            publishId:obj.publishId,
            pendingRejectSort: obj.pendingRejectSort?obj.pendingRejectSort:-1,
            domain: obj.domain,
            titleLike: obj.titleLike,
            postedRangeId: obj.postedRangeId,
            companyStatus: obj.companyStatus,
            companyId: obj.companyId,
            adminType: adminType,
            showDisposableFlag
        };

        const today = moment().format("YYYY-MM-DD");
        const stored = localStorage.getItem("paidJobPrompt");
        if (!stored || stored != today) {
            localStorage.setItem("paidJobPrompt", today);
            checkPaidJobs(adminId).then(res => {
                console.log(res.data.data.paidJobsLength);
                this.setState({
                    paidJobsNotifyModal: res.data.data.paidJobsLength > 0 
                });
            })
        }
        
        state = { ...this.state, ...state }

        this.setState(state)
        const parameters = this.getParameters(state);

        this.fetchCount(adminId, parameters)
        this.fetchJobs(adminId, parameters)

        sortCategories.forEach((category, index) => {
            if (category.id == obj.type) {
                category.arrow = true;
                category.asc = obj.asc;
            }

            if (category.id == "premium-pending")
                this.premiumPendingIndex = index;
        })
    

    }

    deleteJob = (jobId) => {
        this.setState({ loader: true })
        if (window.confirm('Are you sure to delete this Job ? ')) {
            deleteJob(this.state.adminId, jobId)
                .then(res => {
                    this.setState({ loader: false })
                    if (res.status == 'success') {
                        toast.info('Job deleted successfully');
                        const parameters = this.getParameters(this.state);
                        this.fetchCount(this.state.adminId ,parameters)
                        this.fetchJobs(this.state.adminId, parameters)
                    } else {
                        toast.error('Job could not be deleted');
                    }
                })
                .catch(err => {
                    this.setState({ loader: false })
                    toast.error('Job could not be deleted');
                })
        } else {
            this.setState({ loader: false });
        }
    }

    refreshJob = (jobId) => {
        this.setState({ loader: true })        
        if (window.confirm('Do you really want to refresh this posting ?')) {
            refreshJob(this.state.adminId, jobId)
                .then(res => {
                    this.setState({ loader: false })
                    if (res.status == 'success') {
                        toast.info('Job refreshed successfully');
                        const parameters = this.getParameters(this.state);
                        this.fetchCount(this.state.adminId ,parameters)
                        this.fetchJobs(this.state.adminId, parameters)
                    } else {
                        toast.error('Job could not be refreshed');
                    }
                })
                .catch(err => {
                    this.setState({ loader: false })
                    toast.error('Job could not be refreshed');
                })
        } else {
            this.setState({ loader: false });
        }
    }

    rejectJob = (jobId, reasonId, reason) => {
        this.setState({ loader: true })
        const data = {
            reasonId:reasonId,
            reason: reason,
            jobid: jobId
        };
        rejectJob(this.state.adminId, jobId, data)
            .then(res => {
                this.setState({ loader: false })
                if (res.status == 'success') {
                    toast.info('Job rejected successfully');
                    const parameters = this.getParameters(this.state);
                    this.fetchCount(this.state.adminId ,parameters)
                    this.fetchJobs(this.state.adminId, parameters)
                } else {
                    toast.error('Job could not be rejected');
                }
            })
            .catch(err => {
                this.setState({ loader: false })
                toast.error('Job could not be rejected');
            })
    }

    rejectPost = (jobId) => {
        this.setState({ loader: true })
        const data = {
            jobid: jobId
        };
        rejectPost(this.state.adminId, jobId, data)
            .then(res => {
                this.setState({ loader: false })
                if (res.status == 'success') {
                    toast.info('Job rejected successfully and will be posted on hirist');
                    const parameters = this.getParameters(this.state);
                    this.fetchCount(this.state.adminId ,parameters)
                    this.fetchJobs(this.state.adminId, parameters)
                } else {
                    toast.error('Job could not be rejected');
                }
            })
            .catch(err => {
                this.setState({ loader: false })
                toast.error('Job could not be rejected');
            })
    }

    unpublishJob = (jobId, reason) => {
        this.setState({ loader: true })
        const data = {
            reasonId: reason
        };
        unpublishJob(this.state.adminId, jobId, data)
            .then(res => {
                this.setState({ loader: false })
                if (res.status == 'success') {
                    toast.info('Job unpublished successfully');
                    const parameters = this.getParameters(this.state);
                    this.fetchCount(this.state.adminId ,parameters)
                    this.fetchJobs(this.state.adminId, parameters)
                } else {
                    toast.error('Job could not be unpublished');
                }
            })
            .catch(err => {
                this.setState({ loader: false })
                toast.error('Job could not be unpublished');
            })
    }

    bulkUnpublish = dataArr => {
        this.setState({
            loader: true,
            bulkUnpublishLoading: true
        });
        
        bulkUnpublish(this.state.adminId, { jobsData: dataArr })
            .then(res => {
                if (res.data.status == 'success') {
                    if (res.data.errorJobIds && res.data.errorJobIds.length > 0) {
                        toast.info(`Jobs except jobs with ids: ${res.data.errorJobIds.join(',')} unpublished successfully`)
                    } else {
                        toast.info('Jobs unpublished successfully');
                    }
                    const parameters = this.getParameters(this.state);
                    this.fetchCount(this.state.adminId ,parameters)
                    this.fetchJobs(this.state.adminId, parameters)
                } else {
                    toast.error('Jobs could not be unpublished');
                }

                this.setState({
                    loader: false,
                    bulkUnpublishLoading: false,
                    unpublishJobsModal: false,
                    unpublishJobsModalData: {},
                    selectedJobs: [],
                    isSelectAll: false,
                    showBulkActionBtns: false,
                });
            })
            .catch(err => {
                this.setState({ loader: false, bulkUnpublishLoading: false })
                toast.error('Jobs could not be rejected');
            })
    }

    bulkReject = reasonsObj => {
        this.setState({ loader: true, bulkRejectLoading: true });

        const data = {
            reasonData: reasonsObj,
            jobIdArray: this.state.selectedJobs
        }

        bulkReject(this.state.adminId, data)
            .then(res => {
                if (res.data.status == 'success') {
                    if (res.data.errorJobIds && res.data.errorJobIds.length > 0) {
                        toast.info(`Jobs except jobs with ids: ${res.data.errorJobIds.join(',')} rejected successfully`)
                    } else {
                        toast.info('Jobs rejected successfully');
                    }
                    const parameters = this.getParameters(this.state);
                    this.fetchCount(this.state.adminId ,parameters)
                    this.fetchJobs(this.state.adminId, parameters)
                } else {
                    toast.error('Jobs could not be rejected');
                }

                this.setState({
                    loader: false,
                    bulkRejectLoading: false,
                    rejectJobsReasonModal: false,
                    rejectJobsModalData: {},
                    selectedJobs: [],
                    isSelectAll: false,
                    showBulkActionBtns: false,
                });
            }).catch(err => {
                this.setState({ loader: false, bulkRejectLoading: false })
                toast.error('Jobs could not be rejected');
            });
    }

    bulkMigrate = () => {
        this.setState({ loader: true, bulkMigrateLoading: true });

        const jobIdArray = this.state.selectedJobs.filter((job) => !this.state.atsJobs.includes(job));
        const data = {
            jobIdArray: jobIdArray,
            migrateTo: migrateToMap[this.state.bulkMigratePlatform]
        };

        bulkMigrate(this.state.adminId, data)
            .then(res => {
                if (res.data.status == 'success') {
                    if (res.data.errorJobIds && res.data.errorJobIds.length > 0) {
                        toast.info(`Jobs except jobs with ids: ${res.data.errorJobIds.join(',')} migrated successfully`)
                    } else {
                        toast.info('Jobs migrated successfully');
                    }
                    const parameters = this.getParameters(this.state);
                    this.fetchCount(this.state.adminId ,parameters)
                    this.fetchJobs(this.state.adminId, parameters)
                } else {
                    toast.error('Jobs could not be migrated');
                }

                this.setState({
                    loader: false,
                    bulkMigrate: false,
                    bulkMigrateLoading: false,
                    migrateJobsModal: false,
                    selectedJobs: [],
                    isSelectAll: false,
                    showBulkActionBtns: false,
                });
            })
            .catch(error => {
                this.setState({ loader: false, bulkMigrateLoading: false })
                toast.error('Jobs could not be migrated');
            });
    }

    onClickSortButton = (sortId, index) => {

        //Sort categories change
        sortCategories.forEach(category => {
            category.arrow = false
        })

        if (sortId != 'all') {
            sortCategories[index].arrow = true
            sortCategories[index].asc = !sortCategories[index].asc;
        }

        //change query parameters
        if (sortId != 'all') {
            const state = this.state;
            state.arrow = true;
            state.type = sortId;
            state.asc = sortCategories[index].asc;
            state.loader = true;
            state.joblist = [];
            state.selectedJobs = []
            state.isSelectAll = false;
            state.showBulkActionBtns = false;
            state.pageNumber = 1;
            
            //Update state
            this.setState(state)

            const parameters = this.getParameters(state);
            this.fetchCount(this.state.adminId ,parameters)
            this.fetchJobs(this.state.adminId, parameters)

            //send route request
            this.routeRequest(state)
        } else {
            const state = this.state;
            state.type = null;
            state.selectedJobs = []
            state.isSelectAll = false;
            state.showBulkActionBtns = false;
            state.pageNumber = 1;
            state.pageContent = 50;

            this.setState(state);
            this.props.history.push('/')
            this.fetchCount(this.state.adminId ,{})
            this.fetchJobs(this.state.adminId, {})
        }
    }

    onChangeMaxSalButton = (event) => {
        const state = {
            ...this.state,
            loader: true,
            joblist: [],
            maxSalLessThan: event.target.value
        };

        this.setState(state)
        const parameters = this.getParameters(state);
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(state)
    }

    onChangeCompRankButton = (event) => {
        const state = {
            ...this.state,
            loader: true,
            joblist: [],
            companyRank: event.target.value
        };

        this.setState(state)
        const parameters = this.getParameters(state);
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(state)
    }

    onChangePendingRejectSort = (event) => {
        const state = {
            ...this.state,
            loader: true,
            joblist: [],
            pendingRejectSort: event.target.value
        };
        this.setState(state)
        const parameters = this.getParameters(state);
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(state)
    }

    onChangeCategoryButton = (event) => {
        const state = this.state;
        state.loader = true;
        state.joblist = [];
        state.categoryId = event.target.value
        this.setState(state)
        const parameters = this.getParameters(state);
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(state)
    }

    onChangePostingDateButton = (event) => {
        const state = this.state;
        state.loader = true;
        state.joblist = [];
        state.postedRangeId = event.target.value
        this.setState(state)
        const parameters = this.getParameters(state);
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(state)
    }

    onChangeJobNature = (event) => {
        const state = this.state;
        state.loader = true;
        state.joblist = [];
        state.companyStatus = event.target.value;
        this.setState(state);
        const parameters = this.getParameters(state);
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(state);
    }
    onChangeJobStatus = (event) => {
        const state = this.state;
        state.loader = true;
        state.joblist = [];
        state.type = event.target.value;
        this.setState(state);
        const parameters = this.getParameters(state);
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(state);
    }
    onChangeDomainButton = (event) => {
        const state = this.state;
        state.loader = true;
        state.joblist = [];
        state.domainCategory = event.target.value
        this.setState(state)
        const parameters = this.getParameters(state);
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(state)
    }

    onChangeRejectMsgButton = (event) => {
        this.setState({
        //   type: "rejected",
          rejectMsg: event.target.value,
          loader: true,
          joblist: [],
        },()=>{
            const parameters = this.getParameters(this.state);
            this.fetchCount(this.state.adminId, parameters);
            this.fetchJobs(this.state.adminId, parameters);
            this.routeRequest(this.state);
        });
       
    }

    onChangeRecId = (event) => {
        this.setState({
            recruiterId: event.target.value,
        })
    }

    onChangePubId = (event) => {
        this.setState({
            publishId: event.target.value,
        })
    }

    onChangeField = (key, event) => {
        this.setState({
            [key]: event.target.value
        })
    }


    onClickClearField = (key) => {
        this.setState({ 
            loader: true ,
            [key]:'',
            pageNumber:1
        },() => {
            const parameters = this.getParameters(this.state);  
            this.fetchCount(this.state.adminId ,parameters)
            this.fetchJobs(this.state.adminId, parameters)
            this.routeRequest(this.state)
        });
    }

    handleKeyPress = (event) => {
        if (event.key == 'Enter') {
          this.onClickSearchRecId();
        }
    };

    onClickSearchRecId = () => {
        const params=this.getParameters(this.state)
        if(!params.recruiterId && !params.publishId && !params.domain && !params.titleLike && !params.companyId)
            return
     
        this.setState({
             loader: true ,
             pageNumber:1
        })
        const parameters = this.getParameters(this.state);
        parameters.pageNumber=1;
        if(parameters.recruiterId && isNaN(parameters.recruiterId)){
            let params={}
            params.email=parameters.recruiterId
            fetchRecruiterId(this.state.adminId,params).then(res => {
                let data = res.data;
                this.setState({
                    recruiterId: data.id
                }, () => {
                    parameters.recruiterId=data.id;
                    this.fetchCount(this.state.adminId ,parameters)
                    this.fetchJobs(this.state.adminId, parameters)
                    this.routeRequest(this.state)
                });
            }).catch(err=>{
                this.setState({
                    loader: false ,
                    totalItemsCount :0,
                    joblist:[]
               })
               toast.error('No recruiter found');
            });
            return
        }  
        this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters)
        this.routeRequest(this.state)
    }

    onClickClearRecId = () => {
        this.setState({ 
            loader: true ,
            recruiterId:'',
            pageNumber:1
        },() => {
            const parameters = this.getParameters(this.state);  
            this.fetchCount(this.state.adminId ,parameters)
            this.fetchJobs(this.state.adminId, parameters)
            this.routeRequest(this.state)
        });
    }

    onClickClearPubId = () => {
        this.setState({ 
            loader: true ,
            publishId:'',
            pageNumber:1
        },() => {
            const parameters = this.getParameters(this.state);  
            this.fetchCount(this.state.adminId ,parameters)
            this.fetchJobs(this.state.adminId, parameters)
            this.routeRequest(this.state)
        });
    }

    onResetCache = () =>{
            this.setState({ cacheLoader:true },()=>{
                const parameters = this.getParameters(this.state);  
                this.fetchCount(this.state.adminId, { ...parameters, noCache: 1 })
                this.routeRequest(this.state)
            });
    
    }

    getParameters = (state) => {
        const parameters = {
            order: state.asc ? 'asc' : 'desc',
            pageNumber: state.pageNumber,
            pageContent: state.pageContent,
        }
        if (state.type)
            parameters['type'] = state.type

        if(isNaN(state.recruiterId)){
            parameters['recruiterId'] = state.recruiterId
        }    

        if(!isNaN(state.recruiterId) && state.recruiterId > 0){
            parameters['recruiterId'] = state.recruiterId
        }

        if(!isNaN(state.publishId) && state.publishId > 0){
            parameters['publishId'] = state.publishId
        }
        
        if(!isNaN(state.companyId) && state.companyId > 0){
            parameters['companyId'] = state.companyId
        }

        if(state.type=="rejected" || state.type == 'pendingRejected')
        {
            parameters['messageId']=parseInt(state.rejectMsg)>-1?state.rejectMsg:null;
        }
        
        if (state.categoryId > 0)
            parameters['categoryId'] = state.categoryId

        if (state.domainCategory > 0)
            parameters['domainCategory'] = state.domainCategory

        if (state.maxSalLessThan > 0)
            parameters['maxSalaryLessThan'] = state.maxSalLessThan

        if (state.companyRank >= 0)
            parameters['companyRank'] = state.companyRank

        if (state.type == 'pendingRejected' && state.pendingRejectSort != -1) 
            parameters['pendingRejectSort'] = state.pendingRejectSort;

        if (state.domain) {
            const domainArr = state.domain
                .split(/[\s,]+/)         
                .map(domain => domain.trim())  
                .filter(domain => domain);     
                
            parameters.domain = domainArr.join(',');
        }

        if (state.titleLike)
            parameters['titleLike'] = state.titleLike;

        if (state.postedRangeId) {
            if (state.postedRangeId == 1) {
                parameters.postedFrom = moment().subtract(3, "M").format("YYYY-MM-DD")
            } else if (state.postedRangeId == 2) {
                parameters.postedFrom = moment().subtract(1, "Y").format("YYYY-MM-DD")
            }
        }

        if (state.companyStatus && state.companyStatus != '0') {
            parameters['companyStatus'] = state.companyStatus;
        }

        return parameters;
    }

    handlePageChange = (pageNumber) => {
        const state = this.state;
        state.loader = true
        state.pageNumber = pageNumber;
        state.selectedJobs = []
        state.isSelectAll = false;
        state.showBulkActionBtns = false;
        this.setState(state)
        this.routeRequest(state)
        const parameters = this.getParameters(this.state);
        // this.fetchCount(this.state.adminId ,parameters)
        this.fetchJobs(this.state.adminId, parameters);

    }

    fetchCount = (adminId, parameters) => {
        var countParams ={ ...parameters };
        if(parameters )
        {
            delete countParams.pageNumber;
            delete countParams.pageContent;
        }
       
        fetchJobsCount(this.state.adminId, countParams).then(res => {
            const data = res.data;
            this.setState({
                totalItemsCount: data,
                cacheLoader:false
            });
        })
        .catch(err => {
            console.log(err)
        });
    }

    fetchJobs = (adminId, parameters) => {
        if (['unpublishUpdated'].includes(parameters.type) || parameters.pendingRejectSort == 1) {
            parameters.orderBy = 'unixtimestamp'
        }
        fetchAllJobs(this.state.adminId, parameters)
            .then(res => {
                const data = res.data;
                const atsIntegrationData = data.filter((job) => job.atsIntegration).map((job) =>  job.id)
                const universeJobIds = data.filter((job) => job.jobUniverseStatus).map((job) => job.id);
                this.setState({
                    joblist: data,
                    loader: false,
                    atsJobs: atsIntegrationData
                });
                // const recruiterIds = [];
                let recruiterIds = '';
                for(const aData of data) {
                    recruiterIds += aData.uid + ',';
                }
                fetchVerifiedRecruiters(this.state.adminId, { recruiterIds, gmailTypeOnly: 1 })
                    .then(response => {
                        const verifiedRecruiters = response.data;
                        this.setState({verificationStatus: verifiedRecruiters });
                    })

                this.fetchJUPostingStatus(universeJobIds);
            })
            .catch(err => {
                this.setState({ loader: false })
        })
    }

    fetchJUPostingStatus(jobIds) {
        console.log("FETCHING --", jobIds);
        if (!jobIds.length)
            return;

        getJUPostingStatus(this.state.adminId, {
            jobIds: jobIds.join(",")
        }).then(r => {
            console.log(r);
            const fromMailer = r.data.reduce((p, c) => {
                p[c.job_id] = c.integration;
                return p;
            }, {})

            this.setState({
                fromMailer
            });
        })
    }
    
    routeRequest = (parameters) => {
        let array = [];
        for (const key in parameters) {
            if (parameters[key] != null && key !== 'arrow' && key !== 'loader' && key !== 'totalItemsCount' && key !== 'joblist') {
                if (key == 'asc') array.push('order=' + (parameters[key] ? 'asc' : 'desc'))
                else {
                    if (typeof (parameters[key]) == 'number' && parameters[key] > 0)
                        array.push(key + '=' + parameters[key])
                    if (typeof (parameters[key]) == 'string')
                        array.push(key + '=' + parameters[key])
                }

            }
        }

        array = array.join('&')
        this.props.history.push('/?' + array)
    }

    handleModalClose() {
        this.setState({
            paidJobsNotifyModal: false,
            rejectJobsReasonModal: false,
            unpublishJobsModal: false,
            migrateJobsModal: false,
            bulkMigrateLoading: false,
            bulkRejectLoading: false,
            bulkUnpublishLoading: false
        });
    }

    handleOnItemSelected = id => {
        const selected = this.state.selectedJobs;
        if (selected.indexOf(id) !== -1) {
            const updatedSelected = selected.filter(item => item != id);
            this.setState({
                isSelectAll: false, // disable select all checkbox if not all jobs are selected
                selectedJobs: updatedSelected,
                showBulkActionBtns: updatedSelected.length > 0 ? true : false,
                joblist: this.state.joblist.map(item => {
                    if(item.id == id) {
                        return { ...item, isSelected: false }
                    } 
                    return item;
                })
            })
        } else {
            this.setState({
                showBulkActionBtns: true,
                selectedJobs: [...this.state.selectedJobs, id],
                isSelectAll: (this.state.selectedJobs.length + 1) === 50 ? true : false, // check select all box if all jobs are selected
                joblist: this.state.joblist.map(item => {
                    if(item.id == id) {
                        return { ...item, isSelected: true }
                    } 
                    return item;
                })
            });
        }
    }

    handleSelectAll = (event, data) => {
        const jobs = this.state.joblist;
        const selected = [];
        jobs.forEach(job => {
            if (data.checked) {
                selected.push(job.id);
            }
            job.isSelected = data.checked;
        });

        this.setState({
            selectedJobs: selected,
            joblist: jobs,
            isSelectAll: data.checked,
            showBulkActionBtns: data.checked
        });
    };

    handleBulkUnpublish = () => {
        if (this.state.selectedJobs.length === 0) {
            alert('No jobs available to unpublish');

            this.setState({
                isSelectAll: false,
                showBulkActionBtns: false,
            });
            return;
        }

        const tempArr = [];
        this.state.joblist.forEach(job => {
            if (job.isSelected) {
                tempArr.push({
                    id: job.id,
                    recId: job.uid,
                    title: job.title
                })
            }
        })

        this.setState({
            unpublishJobsModal: true,
            unpublishJobsModalData: tempArr
        })
    };

    handleBulkReject = () => {
        if (this.state.selectedJobs.length === 0) {
            alert('No jobs available for reject');
            this.setState({
                isSelectAll: false,
                showBulkActionBtns: false,
            });
            return;
        }
        const tempObj = {};
        this.state.joblist.forEach(job => {
            if (job.isSelected) {
                tempObj[job.id] = job.title;
            }
        })

        this.setState({
            rejectJobsReasonModal: true,
            rejectJobsModalData: tempObj
        })
    }

    handleOnBulkMigrate = platform => {
        if (this.state.selectedJobs.length === 0) {
            alert("No jobs available to migrate");
            this.setState({
                isSelectAll: false,
                showBulkActionBtns: false,
            });
            return;
        }

        this.setState({
            bulkMigratePlatform: platform,
            migrateJobsModal: true,
        });
    }

    handleOnMigrateCancel = () => {
        this.setState({
            bulkMigratePlatform: null,
            migrateJobsModal: false,
            bulkMigrateLoading: false,
        });
    }

    render() {
        const showSelect = ['published', 'refresh', 'pending', 'pendingRejected', 'premium-pending', 'unpublishUpdated'].includes(this.state.type);
        return (
            <div className='page-content'>
                <ToastContainer position='bottom-left'
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover />

                <div className='page-heading'>
                    <Heading text='Jobs posted' />
                    <ButtonContainer heading='Sort By: '>
                        {
                            sortCategories.map((category, i) => (
                                <li key={category.id}> <LinkButtons name={category.name} arrow={category.arrow} arrowType={category.asc} id={category.id} sortClick={() => this.onClickSortButton(category.id, i)} /> </li>
                            ))
                        }
                    </ButtonContainer>
                </div>
                <div className='row category-filter'>
                    <ButtonContainer heading='Categorize By: '>
                        <li key='categoryId'> <Dropdown data={categoryObj} dropdownChange={this.onChangeCategoryButton} defaultValue={this.state.categoryId} /> </li>
                        <li key='domainCategory'> <Dropdown data={domainCategories} dropdownChange={this.onChangeDomainButton} defaultValue={this.state.domainCategory} /> </li>
                        <li key='rejectCategory'> <Dropdown data={rejectCategories} dropdownChange={this.onChangeRejectMsgButton} defaultValue={this.state.rejectMsg} /> </li>
                    </ButtonContainer>
                    <div className='right'>
                        <InputBox placeholder='Enter Recruiter ID' value={this.state.recruiterId} onChange={this.onChangeRecId} onKeyPress={this.handleKeyPress} />
                        <Button skin='dark' disabled={false} text='Search' clickButton={this.onClickSearchRecId} />
                        <Button skin='light' disabled={false} text='Clear' clickButton={this.onClickClearRecId} ></Button>
                    </div>
                </div>
                <div className='row'>
                    <ButtonContainer heading='Filter By: '>
                        <li key='maxSalaryLessThan'> <Dropdown data={this.maxSalary || []} dropdownChange={this.onChangeMaxSalButton} defaultValue={this.state.maxSalLessThan} /> </li>
                        <li key='companyRank'> <Dropdown data={companyRank} dropdownChange={this.onChangeCompRankButton} defaultValue={this.state.companyRank} /> </li>
                    </ButtonContainer>
                    {this.state.type == 'pendingRejected'?
                        <ButtonContainer heading='Sort By: '>
                            <li key="pendingRejectedSort"><Dropdown data={[{ name: 'Select', id: -1 },{ name: 'Updated Time', id: 1 },]} dropdownChange={this.onChangePendingRejectSort} defaultValue={this.state.pendingRejectSort}/></li>
                        </ButtonContainer>
                        :null
                    }
                    <div className='right'>
                        <InputBox placeholder='Enter Publish ID' value={this.state.publishId} onChange={this.onChangePubId} onKeyPress={this.handleKeyPress} />
                        <Button skin='dark' disabled={false} text='Search' clickButton={this.onClickSearchRecId} />
                        <Button skin='light' disabled={false} text='Clear' clickButton={this.onClickClearPubId} ></Button>
                    </div>
                    <div className='right'>
                        <InputBox placeholder='Enter Company ID' value={this.state.companyId} onChange={this.onChangeField.bind(this,"companyId")} onKeyPress={this.handleKeyPress} />
                        <Button skin='dark' disabled={false} text='Search' clickButton={this.onClickSearchRecId} />
                        <Button skin='light' disabled={false} text='Clear' clickButton={this.onClickClearField.bind(this, "companyId")} ></Button>
                    </div>
                </div>
                <div className='row'>
                    <div className='right'>
                        <InputBox placeholder='Enter Domain' value={this.state.domain} onChange={this.onChangeField.bind(this, "domain")} onKeyPress={this.handleKeyPress} />
                        <Button skin='dark' disabled={false} text='Search' clickButton={this.onClickSearchRecId} />
                        <Button skin='light' disabled={false} text='Clear' clickButton={this.onClickClearField.bind(this, "domain")} ></Button>
                    </div>
                    <div className='right'>
                        <InputBox placeholder='Enter Job Title' value={this.state.titleLike} onChange={this.onChangeField.bind(this, "titleLike")} onKeyPress={this.handleKeyPress} />
                        <Button skin='dark' disabled={false} text='Search' clickButton={this.onClickSearchRecId} />
                        <Button skin='light' disabled={false} text='Clear' clickButton={this.onClickClearField.bind(this, "titleLike")} ></Button>
                    </div>
                    <div className='left'>
                        <div className='row'>
                            <ButtonContainer heading='Filter Job By: '>
                                <li key='jobPostingDate'> 
                                    <Dropdown data={[{ name: "Select Job Posting Date", id: 0 }, { name: "Last 3 Months", id: 1 }, { name: "Last Year", id: 2 }]} dropdownChange={this.onChangePostingDateButton} defaultValue={this.state.postedRangeId} />    
                                </li>
                                <li key='companyStatus'>
                                    <Dropdown data={[{ name: "Select Company Status", id: 0 }, { name: "Company", id: 1 }, { name: "Consultant", id: 2 }]} dropdownChange={this.onChangeJobNature} defaultValue={this.state.companyStatus} />
                                </li>
                                <li key='jobStatus'>
                                    <Dropdown data={[{ name: "Select Job Status", id: 0 }, { name: "Pending", id: "jobUniversePending" }, { name: "Published", id: "jobUniversePublished" }]} dropdownChange={this.onChangeJobStatus} defaultValue={this.state.type} />
                                </li>
                            </ButtonContainer>
                        </div>
                    </div>
                </div>
                {!this.state.loader ? (
                    <div className="select-all-container left">
                        {
                            ['published', 'refresh', 'published', 'refresh', 'pending', 'pendingRejected', 'premium-pending', 'unpublishUpdated'].includes(this.state.type) ? (
                                <Checkbox className="select-all-checkbox" label="Select All" checked={this.state.isSelectAll} onChange={this.handleSelectAll}/>
                            ) : null
                        }
                        {this.state.showBulkActionBtns ? (
                            <>
                                {
                                    ['pending', 'pendingRejected', 'premium-pending', 'unpublishUpdated'].includes(this.state.type) ? (
                                        <>
                                            <Button className="btn-bulk-reject" skin='dark' text='Bulk Reject' clickButton={this.handleBulkReject}/>
                                        </>
                                    ) : null
                                }

                                {
                                    ['published', 'refresh'].includes(this.state.type) ? (
                                        <>
                                            <Button className="btn-bulk-unpublish" skin='dark' text='Bulk Unpublish' clickButton={this.handleBulkUnpublish}/>
                                        </>
                                    ) : null
                                }
                                {
                                    ['pending', 'premium-pending'].includes(this.state.type) ? (
                                        <>
                                            {process.env.REACT_APP_PLATFORM == 'iimjobs' ? (
                                                <Button skin='dark' text='Bulk Migrate to hirist' clickButton={() => this.handleOnBulkMigrate('hirist')}/>
                                            ) : null}
                                            {process.env.REACT_APP_PLATFORM == 'hirist' ? (
                                                <Button skin='dark' text='Bulk Migrate to iimjobs' clickButton={() => this.handleOnBulkMigrate('iimjobs')}/>
                                            ) : null}
                                            {

                                                ['iimjobs', 'hirist'].includes(process.env.REACT_APP_PLATFORM) ? (
                                                    <Button skin='dark' text='Bulk Migrate to updazz' clickButton={() => this.handleOnBulkMigrate('updazz')}/>
                                                ) : null
                                            }
                                        </>
                                    ): null
                                }
                            </>
                        ) : null}
                    </div>
                ) : null}
                <div className='row text-center'>
                    <Pagination totalItemsCount={this.state.totalItemsCount} content={this.state.pageContent} pageNumber={this.state.pageNumber} handlePageChange={this.handlePageChange} />
                    <CountDisplay start={(this.state.pageNumber - 1) * this.state.pageContent + 1} end={(this.state.pageNumber-1)*this.state.pageContent + this.state.joblist.length} total={this.state.totalItemsCount} />
                    <Button clickButton={()=>this.onResetCache()} className="pull-right cacheButton" text="Get latest count" loading={this.state.cacheLoader } disabled={this.state.cacheLoader} />
                </div>

                <div>
                    <TableHeading />
                    {this.state.loader ? <Loader /> :
                        (
                            this.state.joblist.map((arow) => (
                                <TableItem item={arow} fromMailer={this.state.fromMailer} key={arow.id} deleteJob={this.deleteJob} refreshJob={this.refreshJob} rejectJob={this.rejectJob} unpublishJob={this.unpublishJob} rejectPost={this.rejectPost} premiumJobs={this.state.type=="premium"?true:false} showDotInfo={this.state.showDotInfo} verified={this.state.verificationStatus[arow['uid']] && this.state.verificationStatus[arow['uid']].verificationStatus} onItemSelected={this.handleOnItemSelected} showSelect={showSelect} pendingRejectSort={this.state.pendingRejectSort} adminType={this.state.adminType} showDisposableFlag={this.state.showDisposableFlag} />
                            ))
                        )
                    }

                </div>

                <div className='row text-center pagination-bottom'>
                    <Pagination totalItemsCount={this.state.totalItemsCount} content={this.state.pageContent} pageNumber={this.state.pageNumber} handlePageChange={this.handlePageChange} />
                </div>

                {
                    this.state.rejectJobsReasonModal ? <BulkRejectModal selectedJobs={this.state.selectedJobs} jobsData={this.state.rejectJobsModalData} openModal={this.state.rejectJobsReasonModal} onModalClose={this.handleModalClose.bind(this)} onBulkReject={this.bulkReject.bind(this)} isLoading={this.state.bulkRejectLoading} /> : null
                }

                {
                    this.state.unpublishJobsModal ? (
                        <BulkUnpublishModal 
                            openModal={this.state.unpublishJobsModal}
                            onCloseModal={this.handleModalClose.bind(this)}
                            isLoading={this.state.bulkUnpublishLoading}
                            selectedJobs={this.state.selectedJobs}
                            onBulkUnpublish={this.bulkUnpublish.bind(this)}
                            jobsData={this.state.unpublishJobsModalData}
                        />
                    ) : null
                }

                {
                    this.state.migrateJobsModal ? <BulkMigrateModal selectedJobs={this.state.selectedJobs} platform={this.state.bulkMigratePlatform} openModal={this.state.migrateJobsModal} onModalClose={this.handleModalClose.bind(this)} onMigrateConfirm={this.bulkMigrate.bind(this)} onMigrateCancel={this.handleOnMigrateCancel.bind(this)} isLoading={this.state.bulkMigrateLoading} /> : null
                }

                    {
                        <Modal open={this.state.paidJobsNotifyModal} onClose={this.handleModalClose.bind(this)}>
                        {/* <Header content={"Mailer Stats"} /> */}
                        <Modal.Content>
                            <div className="paid-jobs-section">
                                <img className='close-img' src="/static/close-copy.svg" onClick={this.handleModalClose.bind(this)} />
                                <img className='premium-img' src="/static/premium.png" />
                                <p style={{ textAlign: "center" }}>Premium jobs were posted while you were away.</p>
                                <a className="job-link" onClick={() => {
                                    this.onClickSortButton("premium-pending", this.premiumPendingIndex);
                                    this.handleModalClose();
                                    }}>
                                    Review premium jobs now
                                    <img className="icon-arrow" src="/static/farrow.svg" />
                                </a>
                            </div>
                        </Modal.Content>
                        {/* <Modal.Actions>
                            <Button clickButton={this.handleModalClose} skin="light" text="Close">
                            </Button>
                        </Modal.Actions> */}
                    </Modal>
                    }

            </div>
        )
    }
}

JobListContainer.propTypes = {
    location: PropTypes.any,
    history: PropTypes.any
}

export default withRouter(JobListContainer);